<template>
  <div class="widget white_box">
    <div class="widget_header">
      <h3 class="heading">
        Average Keyword Ranking
      </h3>
      <a
        v-if="!editing && !preview"
        class="btn primary_btn btn_sm"
        href="/keywords"
      >
        See More
      </a>
      <div
        v-if="editing && !preview"
        class="edit_buttons"
      >
        <button
          class="btn btn_sm btn-danger"
          @click="$parent.remove(widget)"
        >
          Delete
        </button>
      </div>
    </div>
    <apexchart
      v-if="!loading"
      :options="chartOptions"
      :series="series"
      height="300"
      type="line"
    />

    <div
      v-else
      class="loading_widget_data"
    >
      <i class="fa fa-btn fa-spinner fa-spin" /> Loading Data
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex';
import axios from 'axios';

export default {
  props: {
    editing: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: true,
      series: [{
        name: "Average Ranking",
        data: []
      }],
      options: {
        colors: ['#0c9bef', '#969696'],
        xaxis: {
          categories: [],
          type: 'datetime',
        },
        yaxis: [{
          reversed: true,
          min: 1,
          max: 100,
          forceNiceScale: true
        }],
        tooltip: {
          x: {
            format: 'd MMM yyyy',
          }
        }
      }
    }
  },
  computed: {
    ...mapState('dashboard', ['chartBaseOptions', 'uuid', 'preview']),
    chartOptions() {
      return {
        ...this.chartBaseOptions,
        ...this.options
      };
    }
  },
  mounted() {
    axios.post('/ajax/dashboard/get-widget-data', {
      type: 'averageKeywordRanking',
      uuid: this.uuid,
    }).then(response => {
      let data = response.data.average;
      this.series[0].data = data.data;
      this.options.xaxis.categories = data.labels;
      this.loading = false;
    }).catch(error => {
      console.log(error);
    });
  },
}
</script>
